import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand } from '~/brand'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'

interface StateInterface {
  updatedEmail?: string
  loading: boolean
  error?: string
}

const InitialState = {
  loading: false,
}

export default function useChangeEmail() {
  const { customerService } = useAppDepsContext()
  const { brand } = useBrand()
  const { agent } = useSelector(selectAgent)

  const [state, setState] = useState<StateInterface>(InitialState)

  function changeEmail(customerId: string, email: string) {
    setState({ ...InitialState, loading: true })

    customerService
      .updateCustomer({ brand, customerId, email, sub: agent?.sub })
      .then(() => {
        setState({ ...InitialState, loading: false, updatedEmail: email })
      })
      .catch((error: string) => {
        setState({ ...InitialState, loading: false, error })
      })
  }

  return {
    state,
    changeEmail,
    clearChangeEmailError: () => setState({ ...state, error: undefined }),
  }
}
